import {componentType} from './editor';
import {componentLabel} from '../utils/editor';
import commentIcon from './comment.svg';

export function loadBlock(editor, opts = {}) {
  editor.BlockManager.add(componentType, {
    label: componentLabel('Tooltip', commentIcon),
    category: opts.category,
    content: {
      type: componentType,
      content: 'tooltip'
    }
  });
}
